import React, { Component } from 'react';

import styles from 'components/MenuStyles.module.scss';
import ErrorModal from 'components/Utility/ErrorModal';

export default class Menu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            showConfirmLeave: false,
        };
    }

    toggleMenu = () => {
        this.setState({ open: !this.state.open });
    }

    closeConfirmLeave = () => {
        this.setState({ showConfirmLeave: false });
    };
    handleConfirmLeave = () => {
        this.setState({ showConfirmLeave: true });
    };
    goToLobby = () => {
        this.props.room.send("change_game", {});
        this.props.toggleMenu();
        this.closeConfirmLeave();
    };


    render() {
        return (
            <div className={`${styles.menuContainer} ${this.props.menuOpen ? styles.open : ""} `}>
                <div className={`${styles.menuSection} ${this.props.menuOpen ? styles.open : ""}`}>
                    {/*<div className={`${styles.toggle}`} onClick={this.toggleMenu}>{this.state.open ? "Close" : "Open"} Menu</div>*/}
                    <div className={styles.spacer} />
                    {
                        this.props.toggleMute &&
                        <>
                            <div className={styles.button} onClick={() => this.props.toggleMute()}>{this.props.muted ? "Unmute" : "Mute"}</div>
                            <div className={styles.spacer} />
                        </>
                    }
                    <div className={styles.button} onClick={this.handleConfirmLeave}>Go To Lobby</div>
                    <div className={styles.spacer} />
                    <div className={styles.button} onClick={() => this.props.toggleMenu()}>Close</div>
                    <div className={styles.spacer} />
                </div>
                {this.state.showConfirmLeave &&
                    <ErrorModal
                        title="Are you sure?"
                        message={"Are you sure you want to return to the Game.City Lobby?"}
                        callback={this.closeConfirmLeave}
                        callbackText="Cancel"
                        callback2={this.goToLobby}
                        callbackText2={"Go To Lobby"}
                    />
                }
             </div>
        )
    }

}